var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01649 2.49881C5.07623 1.38699 6.61173 0.812863 8.5028 0.818399H17.939C19.8296 0.818399 21.3669 1.39542 22.4287 2.50788C23.4865 3.61618 24.0014 5.18151 24.0014 7.02151V16.9792C24.0014 18.8169 23.4762 20.3831 22.4015 21.4919C21.324 22.6037 19.7657 23.1823 17.8491 23.1823H8.50194C6.61 23.1823 5.07498 22.602 4.01593 21.4878C2.96122 20.3783 2.44922 18.8134 2.44922 16.9792V7.0108C2.44922 5.17175 2.96096 3.6062 4.01649 2.49881Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5829 12.8526C12.5287 12.8526 11.6706 11.9947 11.6706 10.9406C11.6706 9.88648 12.5287 9.02852 13.5829 9.02852C14.637 9.02852 15.4944 9.88648 15.4944 10.9406C15.4944 11.9947 14.637 12.8526 13.5829 12.8526ZM13.5829 5.41992C10.5159 5.41992 8.0201 7.91551 8.0201 10.9829C8.0201 14.8888 12.589 18.5874 13.5829 18.5874C14.5767 18.5874 19.1456 14.8888 19.1456 10.9829C19.1456 7.91551 16.6498 5.41992 13.5829 5.41992ZM1.17055 6.06898C0.524079 6.06898 0 6.593 0 7.23943C0 7.88584 0.524079 8.40988 1.17055 8.40988H5.04604C5.69252 8.40988 6.2166 7.88584 6.2166 7.23943C6.2166 6.593 5.69252 6.06898 5.04604 6.06898H1.17055ZM0 16.7512C0 16.1048 0.524079 15.5808 1.17055 15.5808H5.04604C5.69252 15.5808 6.2166 16.1048 6.2166 16.7512C6.2166 17.3977 5.69252 17.9217 5.04604 17.9217H1.17055C0.524079 17.9217 0 17.3977 0 16.7512Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address_book.8e3ef80a.svg";
export { ForwardRef as ReactComponent };